import { formatDate } from "@angular/common";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { ITableColumnHeader } from "src/app/models/table-column-header";
import { ApiService } from "src/app/providers/api.service";
import { AuthService } from "src/app/providers/auth.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { NavigationService } from "src/app/providers/navigation.service";
import { NotificationService } from "src/app/services/notification.service";
import { BookingDetailsForMemberComponent } from "src/app/shared/components/booking-details-for-member/booking-details-for-member.component";
import { CancelBookingNotesModalComponent } from "src/app/shared/components/cancel-booking-notes-modal/cancel-booking-notes-modal.component";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { CustomerBookingDetailsComponent } from "src/app/shared/components/customer-booking-details/customer-booking-details.component";
import { InvoiceForReportComponent } from "src/app/shared/components/invoice-for-report/invoice-for-report.component";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
@Component({
  selector: "sm-all-upcoming-appointments",
  templateUrl: "./all-upcoming-appointments.component.html",
  styleUrls: ["./all-upcoming-appointments.component.scss"],
})
export class AllUpcomingAppointmentsComponent implements OnInit, OnDestroy {
  upcomingAppointmentsData: any = [];
  toshowData: boolean = true;
  loader: boolean = false;
  _apisub: Subscription;
  pageNo: number = 1;
  constructor(
    private _apiservice: ApiService,
    private _modelRef: MatDialog,
    private navservice: NavigationService,
    private loaderservice: LoaderServiceService,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private notificationService: NotificationService
  ) {
    this.navservice.hideSidebarAndNav = false;
    this.listenForNewBookingUpdates();
    this.listenForBookingStatusUpdates();
    this.listenForMemberAttendance();
    this.listenForMemberBookingStatusUpdate();
    this.listenForBookingAssignmentUpdates();
    this.listenForMemberBookingAssignmentUpdates();
    this._apisub = this._apiservice.apiResult.subscribe((resdata) => {
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_UPCOMING_BOOKINGS_FOR_DASHBOARD
      ) {
        this.upcomingAppointmentsData = [];
        if (resdata.result) {
          resdata.result.forEach((element: any) => {
            if (element.data_type == 1) {
              if (element.booking_type == 0) {
                element.bookingType = "Home service";
              } else if (element.booking_type == 1) {
                element.bookingType = "Shop service";
              } else if (element.booking_type == 2) {
                element.bookingType = "Virtual service";
              }

              if (
                element.appointment_status == 0 ||
                element.appointment_status == 1 ||
                element.appointment_status == 2
              ) {
                element.bookingStat = "New";
              } else if (element.appointment_status == 3) {
                element.bookingStat = "In-progress";
              } else if (element.appointment_status == 4) {
                element.bookingStat = "Completed";
              } else if (element.appointment_status == 5) {
                element.bookingStat = "Confirmed";
              } else if (element.appointment_status == 6) {
                element.bookingStat = "Cancelled";
              } else if (element.appointment_status == 7) {
                element.bookingStat = "Assigned";
              } else if (element.appointment_status == 8) {
                element.bookingStat = "Cancelled";
              } else if (element.appointment_status == 9) {
                element.bookingStat = "In-progress";
              } else {
                element.bookingStat = "--";
              }

              if (
                element.booking_start_time &&
                element.booking_start_time != null
              ) {
                element.booking_start_time = element.booking_start_time.slice(
                  0,
                  5
                );
              }
              if (element.booking_date && element.booking_date != null) {
                const date = new Date(element.booking_date);
                element.u_booking_date = formatDate(
                  date,
                  "MMM d, yyyy",
                  "en-US"
                );
              }
              if (
                element.booking_end_time &&
                element.booking_end_time != null
              ) {
                element.booking_end_time = element.booking_end_time.slice(0, 5);
              }
              if (
                !element.employee_name ||
                element.employee_name == "" ||
                element.employee_name == "null"
              ) {
                element.employee_name = "---";
              }
              element.phone =
                element.country_code + " " + element.customer_phone;
              element.time =
                element.booking_start_time + " - " + element.booking_end_time;

               if(element.booking_address){
                element.booking_address = typeof element.booking_address == 'string' ? JSON.parse(element.booking_address) : element.booking_address
                element.business_address = `Visit: ${element.booking_address.address_line}`
              }

              this.upcomingAppointmentsData.push(element);
            } else if (element.data_type == 2) {
              if (element.booking_type == 0) {
                element.bookingType = "Home service";
              } else if (element.booking_type == 1) {
                element.bookingType = "In-premise service";
              } else if (element.booking_type == 2) {
                element.bookingType = "Virtual service";
              }

              if (element.appointment_status == 0) {
                element.bookingStat = "Absent";
              } else {
                if (element.session_status == 1) {
                  element.bookingStat = "Assigned";
                } else if (element.session_status == 2) {
                  element.bookingStat = "In-progress";
                } else if (element.session_status == 3) {
                  element.bookingStat = "Completed";
                } else if (element.appointment_status == 1) {
                  element.bookingStat = "Present";
                } else {
                  element.bookingStat = "Membership";
                }
              }

              if (
                element.booking_start_time &&
                element.booking_start_time != null
              ) {
                element.booking_start_time = element.booking_start_time.slice(
                  0,
                  5
                );
              }
              if (element.booking_date && element.booking_date != null) {
                const weekdays = [
                  "Sunday",
                  "Monday",
                  "Tuesday",
                  "Wednesday",
                  "Thursday",
                  "Friday",
                  "Saturday",
                ];
                const weekdayIndex = parseInt(element.booking_date, 10) - 1;
                element.u_booking_date = weekdays[weekdayIndex];
              }
              if (
                element.booking_end_time &&
                element.booking_end_time != null
              ) {
                element.booking_end_time = element.booking_end_time.slice(0, 5);
              }
              element.employee_name = element.employee_name
                ? element.employee_name
                : "---";
              element.phone =
                element.country_code + " " + element.customer_phone;
              element.time =
                element.booking_start_time + " - " + element.booking_end_time;

              if (element.serviceInfo) {
                if (element.serviceInfo != null) {
                  element.serviceInfo =
                    typeof element.serviceInfo == "string"
                      ? JSON.parse(element.serviceInfo)
                      : element.serviceInfo;
                  element.servicesArray = [];
                  element.serviceInfo.forEach((item: any) => {
                    element.servicesArray.push(" " + item.service_name);
                  });
                }
              }
              if (element.custom_items) {
                if (element.custom_items != null) {
                  element.custom_items =
                    typeof element.custom_items == "string"
                      ? JSON.parse(element.custom_items)
                      : element.custom_items;
                  element.customItemsArray = [];
                  element.custom_items.forEach((item: any) => {
                    element.customItemsArray.push(" " + item.item_name);
                  });
                }
              }
              if (element.appointment_products) {
                if (element.appointment_products != null) {
                  element.appointment_products =
                    typeof element.appointment_products == "string"
                      ? JSON.parse(element.appointment_products)
                      : element.appointment_products;
                  // element.customItemsArray = []
                  // element.serviceInfo.forEach((item:any) => {
                  //   element.customItemsArray.push(' ' + item.item_name)
                  // });
                }
              }
               if (element.booking_type == 0 && (element.booking_address && element.booking_address != '' && element.booking_address != 'null')) {
                element.business_address = `Visit: ${element.booking_address}`;
              }else if(element.booking_type == 0 && (!element.booking_address || element.booking_address == '' || element.booking_address == 'null')){
                element.business_address = 'No address info';
              }
              this.upcomingAppointmentsData.push(element);
            }
          });
        }
        loaderservice.showLoader = false;
        this.loader = false;
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_UPDATE_BOOKING_STATUS
      ) {
        this._apiservice.getUpcomingBookingsForDashboard("500", this.pageNo);
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_PAYMENT_RECORD
      ) {
        this._apiservice.getUpcomingBookingsForDashboard("500", this.pageNo);
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_ADD_EDIT_INTERNATIONAL_INVOICE_PAYMENT_RECORD
      ) {
        this._apiservice.getUpcomingBookingsForDashboard("500", this.pageNo);
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_DELETE_ENTITY_APPOINTMENT_DATA
      ) {
        this._apiservice.getUpcomingBookingsForDashboard("500", this.pageNo);
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_DELETE_ENTITY_INVOICE
      ) {
        this._apiservice.getUpcomingBookingsForDashboard("500", this.pageNo);
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_DELETE_INTERNATIONAL_INVOICE_DETAILS
      ) {
        this._apiservice.getUpcomingBookingsForDashboard("500", this.pageNo);
      }
    });
  }

  ngOnInit(): void {
    this.loader = true;
    this.loaderservice.showLoader = true;
    this._apiservice.getUpcomingBookingsForDashboard("500", this.pageNo);
  }

  // tableDisplayColumns: string[] = ['image', 'name', 'shop', 'payment', 'time', 'assigned', 'status'];

  bookingData = [
    {
      image:
        "https://img.freepik.com/free-photo/young-bearded-man-with-striped-shirt_273609-5677.jpg",
      name: "Rahul raj Rathod",
      phone: "+91 8989835354",
      shop: "Mithali Hair, Spa, Balanced Beauty",
      location:
        "Kali Bari, UCP 26, near Ambuja, Bengal Ambuja Durgapur, West Bengal 713216",
      date: "2024-07-20",
      service: "Shop",
      starus: "In-progress",
    },
    {
      image:
        "https://img.freepik.com/free-photo/young-bearded-man-with-striped-shirt_273609-5677.jpg",
      name: "Suraj Paul",
      phone: "+91 8989835354",
      shop: "Evonie Hair Salon & Makeup Studio",
      location:
        "2nd floor, Raj sammilonee MAX mall, Bhiringi, Benachity, Durgapur, West Bengal 713213",
      date: "2024-07-20",
      service: "Home",
      starus: "In-progress",
    },
    {
      image:
        "https://media.istockphoto.com/id/1136413215/photo/young-man-at-street-market.jpg?s=612x612&w=0&k=20&c=obnaR5III0jRxHKd4ZPl3LRC2pI792KbHYR2eBzKKe8=",
      name: "Sourav Das",
      phone: "+91 8989835354",
      shop: "Invogue Salon Spa & NailBar",
      location:
        "2nd Floor, Kamdhenu, Bengal Shrishti, above HDFC Bank, Durgapur, West Bengal 713216",
      date: "2024-07-20",
      service: "Shop",
      starus: "Completed",
    },
    {
      image:
        "https://easy-peasy.ai/cdn-cgi/image/quality=80,format=auto,width=700/https://fdczvxmwwjwpwbeeqcth.supabase.co/storage/v1/object/public/images/8f706226-0b67-41ea-b84e-a7add4ea0658/fadf9214-bad0-41cb-8318-272d81dfe466.png",
      name: "Rahul raj Rathod",
      phone: "+91 8989835354",
      shop: "Mithali Hair, Spa, Balanced Beauty",
      location:
        "Kali Bari, UCP 26, near Ambuja, Bengal Ambuja Durgapur, West Bengal 713216",
      date: "2024-07-20",
      service: "Home",
      starus: "In-progress",
    },
    {
      image:
        "https://www.shutterstock.com/image-photo/cheerful-black-man-wearing-leather-600nw-2238222273.jpg",
      name: "Rahul raj Rathod",
      phone: "+91 8989835354",
      shop: "Mithali Hair, Spa, Balanced Beauty",
      location:
        "Kali Bari, UCP 26, near Ambuja, Bengal Ambuja Durgapur, West Bengal 713216",
      date: "2024-07-20",
      service: "Home",
      starus: "Completed",
    },
    {
      image:
        "https://media.istockphoto.com/id/613557584/photo/portrait-of-a-beautifull-smiling-man.jpg?s=612x612&w=0&k=20&c=hkCg5CrmTKOApePbPOyo1U9GexEfIJOJqoLXJIvcN8E=",
      name: "Rahul raj Rathod",
      phone: "+91 8989835354",
      shop: "Mithali Hair, Spa, Balanced Beauty",
      location:
        "Kali Bari, UCP 26, near Ambuja, Bengal Ambuja Durgapur, West Bengal 713216",
      date: "2024-07-20",
      service: "Home",
      starus: "In-progress",
    },
    {
      image:
        "https://t4.ftcdn.net/jpg/02/70/84/61/360_F_270846119_LKNW0GcldOoicB0D4jKChIqClQl2Bd2N.jpg",
      name: "Rahul raj Rathod",
      phone: "+91 8989835354",
      shop: "Mithali Hair, Spa, Balanced Beauty",
      location:
        "Kali Bari, UCP 26, near Ambuja, Bengal Ambuja Durgapur, West Bengal 713216",
      date: "2024-07-20",
      service: "Shop",
      starus: "In-progress",
    },
    {
      image:
        "https://t4.ftcdn.net/jpg/01/34/51/81/360_F_134518160_5DyP0y6YqXQgG6FdorIvpk7M6CBNrglm.jpg",
      name: "Rahul raj Rathod",
      phone: "+91 8989835354",
      shop: "Mithali Hair, Spa, Balanced Beauty",
      location:
        "Kali Bari, UCP 26, near Ambuja, Bengal Ambuja Durgapur, West Bengal 713216",
      date: "2024-07-20",
      service: "Home",
      starus: "Completed",
    },
    {
      image:
        "https://images.rawpixel.com/image_800/cHJpdmF0ZS9sci9pbWFnZXMvd2Vic2l0ZS8yMDIzLTA4L3Jhd3BpeGVsX29mZmljZV8yX3Bob3RvX29mX2FfYmxhY2tfYnVzaW5lc3NtYW5faXNvbGF0ZWRfb25fb2ZmX19lZmMxZDllNC1iNzQ5LTQ2NzMtYjRmMS1lYjI0NTBiYzNiOGRfMS5qcGc.jpg",
      name: "Rahul raj Rathod",
      phone: "+91 8989835354",
      shop: "Mithali Hair, Spa, Balanced Beauty",
      location:
        "Kali Bari, UCP 26, near Ambuja, Bengal Ambuja Durgapur, West Bengal 713216",
      date: "2024-07-20",
      service: "Home",
      starus: "Completed",
    },
    {
      image:
        "https://img.freepik.com/free-photo/young-bearded-man-with-striped-shirt_273609-5677.jpg",
      name: "Rahul raj Rathod",
      phone: "+91 8989835354",
      shop: "Mithali Hair, Spa, Balanced Beauty",
      location:
        "Kali Bari, UCP 26, near Ambuja, Bengal Ambuja Durgapur, West Bengal 713216",
      date: "2024-07-20",
      service: "Shop",
      starus: "Completed",
    },
  ];

  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: "name",
      columnProperty: "customer_name",
    },
    {
      columnName: "phone",
      columnProperty: "phone",
    },
    {
      columnName: "shop",
      columnProperty: "business_name",
    },
    {
      columnName: "location",
      columnProperty: "business_address",
    },
    {
      columnName: "date",
      columnProperty: "u_booking_date",
    },
    {
      columnName: "service",
      columnProperty: "bookingType",
    },
    {
      columnName: "assigned to",
      columnProperty: "employee_name",
    },

    {
      columnName: "status",
      columnProperty: "bookingStat",
    },
  ];

  ngOnDestroy(): void {
    this._apisub.unsubscribe();
    if (this.newbookingsubscription) {
      this.newbookingsubscription.unsubscribe();
    }
    if (this.bookingStatusUpdatedsubscription) {
      this.bookingStatusUpdatedsubscription.unsubscribe();
    }
    if (this.memberattendancesubscription) {
      this.memberattendancesubscription.unsubscribe();
    }
    if (this.memberbookingstatuschangedsubscription) {
      this.memberbookingstatuschangedsubscription.unsubscribe();
    }
    if (this.bookingAssignmentsubscription) {
      this.bookingAssignmentsubscription.unsubscribe();
    }
    if (this.memberBookingAssignmentsubscription) {
      this.memberBookingAssignmentsubscription.unsubscribe();
    }
  }

  deleteBooking(item: any) {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      data: {
        title: "Alert",
        message: "Are you sure you want to delete this booking?",
        okbtn: "Confirm",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let obj = {
          appointmentHash: item.booking_hash,
          entityHash: item.business_hash,
        };

        this.loaderservice.showLoader = true;
        this._apiservice.deleteEntityAppointmentData(obj);
      }
    });
  }

  private newbookingsubscription: Subscription = new Subscription();
  listenForNewBookingUpdates() {
    this.newbookingsubscription = this.notificationService
      .getNotificationByType("newBooking")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          payload.data.misc =
            typeof payload.data.misc == "string"
              ? JSON.parse(payload.data.misc)
              : payload.data.misc;
          if (true) {
            this._apiservice.getUpcomingBookingsForDashboard(
              "500",
              this.pageNo
            );
          }
        }
      });
  }

  private bookingStatusUpdatedsubscription: Subscription = new Subscription();
  listenForBookingStatusUpdates() {
    this.bookingStatusUpdatedsubscription = this.notificationService
      .getNotificationByType("bookingStatusUpdated")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          payload.data.misc =
            typeof payload.data.misc == "string"
              ? JSON.parse(payload.data.misc)
              : payload.data.misc;
          if (true) {
            this._apiservice.getUpcomingBookingsForDashboard(
              "500",
              this.pageNo
            );
          }
        }
      });
  }
  private bookingAssignmentsubscription: Subscription = new Subscription();
  listenForBookingAssignmentUpdates() {
    this.bookingAssignmentsubscription = this.notificationService
      .getNotificationByType("onCustomerAssign")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          payload.data.misc =
            typeof payload.data.misc == "string"
              ? JSON.parse(payload.data.misc)
              : payload.data.misc;
          if (true) {
            this._apiservice.getUpcomingBookingsForDashboard(
              "500",
              this.pageNo
            );
          }
        }
      });
  }

  private memberattendancesubscription: Subscription = new Subscription();
  listenForMemberAttendance() {
    this.memberattendancesubscription = this.notificationService
      .getNotificationByType("onMemberAttendance")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          payload.data.misc =
            typeof payload.data.misc == "string"
              ? JSON.parse(payload.data.misc)
              : payload.data.misc;
          if (true) {
            this._apiservice.getUpcomingBookingsForDashboard(
              "500",
              this.pageNo
            );
          }
        }
      });
  }
  private memberbookingstatuschangedsubscription: Subscription =
    new Subscription();
  listenForMemberBookingStatusUpdate() {
    this.memberbookingstatuschangedsubscription = this.notificationService
      .getNotificationByType("memberBookingStatusUpdated")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          payload.data.misc =
            typeof payload.data.misc == "string"
              ? JSON.parse(payload.data.misc)
              : payload.data.misc;
          if (true) {
            this._apiservice.getUpcomingBookingsForDashboard(
              "500",
              this.pageNo
            );
          }
        }
      });
  }
  private memberBookingAssignmentsubscription: Subscription =
    new Subscription();
  listenForMemberBookingAssignmentUpdates() {
    this.memberBookingAssignmentsubscription = this.notificationService
      .getNotificationByType("onMemberAssign")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          payload.data.misc =
            typeof payload.data.misc == "string"
              ? JSON.parse(payload.data.misc)
              : payload.data.misc;
          if (true) {
            this._apiservice.getUpcomingBookingsForDashboard(
              "500",
              this.pageNo
            );
          }
        }
      });
  }

  bookingDetails(item: any) {
    // this._modelRef.open(CustomerBookingDetailsComponent, {
    //   width: '700px',
    //   data: {
    //     title: 'Bookings Details',
    //     ref: this._modelRef,
    //     data: item.booking_hash,
    //   },
    // });
    this.authService.setUserRole(item.is_owner == 1 ? "owner" : "employee");
    localStorage.setItem(
      SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID,
      item.employee_hash_id
    );
    localStorage.setItem(
      SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,
      item.entity_public_hash_id
    );

    if (item.data_type == 1) {
      this.router.navigate(["booking-details"], {
        relativeTo: this.route,
        queryParams: {
          bookingHash: item.booking_hash,
          entityHash: item.business_hash,
          eph: item.entity_public_hash_id
        },
      });
    } else if (item.data_type == 2) {
      this.router.navigate(["membership-booking-details"], {
        relativeTo: this.route,
        queryParamsHandling: "merge",
        queryParams: {
          memberHash: item.member_hash,
          isf: "1",
          entityHash: item.business_hash,
          bd: item.booking_date,
        },
      });
    }
  }

  confirmBooking(item: any) {
    let data = {
      bookingStatusInfo: {
        assignedToHash: item.employee_hash_id,
        assignedByHash: item.employee_hash_id,
        appointmentHash: item.booking_hash,
        bookingStatus: 5,
        startTime: item.booking_start_time.slice(0, 5),
        endTime: item.booking_end_time.slice(0, 5),
        entityHash: item.business_hash,
        countryCode: item.country_code,
        customerPh: item.customer_phone,
        customerName: item.customer_name,
        price: item.booking_price,
        bookingDate: item.booking_date,
        note: item.booking_note,
        bookingType: item.booking_type,
        customerHash: item.customer_hash,
      },
    };

    console.log(data);
    this.loaderservice.showLoader = true;
    this._apiservice.updateBookingStatus(data);
  }

  cancelBooking(item: any) {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      data: {
        title: "Alert",
        message: "Are you sure you want to cancel this booking?",
        okbtn: "Confirm",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let notedialogref = this._modelRef.open(
          CancelBookingNotesModalComponent,
          {
            width: "600px",
            data: {
              title: "Cancel Booking",
            },
          }
        );
        notedialogref.afterClosed().subscribe((res) => {
          if (res) {
            let data = {
              bookingStatusInfo: {
                bookingStatus: 8,
                assignedToHash: item.employee_hash_id,
                assignedByHash: item.employee_hash_id,
                appointmentHash: item.booking_hash,
                startTime: item.booking_start_time.slice(0, 5),
                endTime: item.booking_end_time.slice(0, 5),
                entityHash: item.business_hash,
                countryCode: item.country_code,
                customerPh: item.customer_phone,
                customerName: item.customer_name,
                price: item.booking_price,
                bookingDate: item.booking_date,
                note: item.note,
                cancellationNotes: res.notes,
                bookingType: item.booking_type,
                customerHash: item.customer_hash,
              },
            };

            console.log(data);
            this.loaderservice.showLoader = true;
            this._apiservice.updateBookingStatus(data);
          }
        });
      }
    });
  }

  openInvoice(item: any) {
    this._modelRef.open(InvoiceForReportComponent, {
      width: "510px",
      data: {
        title: "Invoice",
        ref: this._modelRef,
        data: item.booking_hash,
      },
    });
  }

  viewDetailsForMember(item: any) {
    this._modelRef.open(BookingDetailsForMemberComponent, {
      width: "600px",
      disableClose: true,
      data: {
        data: item,
      },
    });
  }

  // NEW CODE FOR ROW CLICK
 rowClickHandler = (row: any) => {
  this.bookingDetails(row);
};
}
